const brandsReducer = (state = null, action) => {
    switch (action.type) {
        case "GET_BRANDS":
            return action.payload;
        default:
            return state;
    }
};
export default brandsReducer;
